import React from 'react';

import css from './CheckListItem.module.scss';

interface Props {
  children: any;
  redesignCheckListItem?: boolean;
  hasLink?: boolean;
  image?: string;
  'data-e2e'?: string;
}

const CheckListItem = ({
  children,
  hasLink = false,
  image = 'green-check-circle',
  'data-e2e': dataE2e
}: Props) => {
  return (
    <div
      className={`${css.checkListItem} ${hasLink && css.hasLink}`}
      data-e2e={dataE2e}
    >
      <img src={`../../../static/${image}.svg`} alt={image} />
      <div className={css.checkListItemContent}>{children}</div>
    </div>
  );
};

export default CheckListItem;
